<template>
  <div name="pupilmove" class="-mx-3 -mt-4 pb-10 pt-4">

    <section v-if="errored" class="w-full text-center mt-2">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue moving the evidence details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <div class="">
  
    <div class="grid grid-cols-1 space-y-1 py-4 mt-2 border-b border-gray-300">
      <div class="mx-6">
        <label class="font-semibold">Set new lesson:</label>
        <a
          class="text-xs cursor-pointer right text-red-400 mb-2"
          @click="lessonMoveSelected = {}"
          >Clear</a
        >

        <ul class="mt-2 w-full">
          <li
    v-for="(item, index) in orderedLessons"
    :key="index"
    class="inline-block mr-2"
  >
    <button
      type="button"
      @click="setMoveLesson(item)"
      class="selection-button mb-3 hover:bg-opacity-50 wide"
      v-bind:class="
        lessonMoveButtonPressed(item)
        ? 'filter-item-button-on'
                  : 'filter-item-button-off'
      "
    >
      {{ item.name }}
    </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="grid grid-cols-2 space-y-1 py-4 border-b border-gray-300">
      <div class="ml-6 pr-4 border-r">
        <label class="font-semibold mb-2 pb-2"> Class / Group</label>
        <div class="mt-2 -ml-1">
          <ClassDropdown @classValueChanged="classSelect"></ClassDropdown>
        </div>
      </div>

      <div class="pt-6 mx-4">
        <input
          v-model="newClass"
          class="mb-2"
          id="grid-sen"
          type="text"
          placeholder="Or enter new class..."
        />
      </div>
    </div>

    <div class="h-10 text-left mt-4 ml-6 mb-10">

      <button
        @click="moveEvidence()"
        type="button"
        class="publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4 mt-6"
        :disabled="isMoveDisabled"
      >
        Move Evidence
      </button>
    </div>
  </div>

  </div>
</template>




<script>
import { EvidenceService } from "@/services/evidence.service";

const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";

export default {
  name: "pupilmove",
  mixins: [yearGroupMixin],
  components: {
    ClassDropdown,
  },
  props: {
    evidences: { type: Array, required: true },
    lessons: { type: Array, required: true }
  },
  computed: {
    isMoveDisabled() {
      return (
        this.lessonMoveSelected.id == undefined &&
        (this.classMoveSelected.id == undefined || this.classMoveSelected.id === 0)
      );
    },
    orderedLessons() {
      return this.lessons
    }
  },
  data() {
    return {
      lessonMoveSelected: {},
      classMoveSelected: {},
      errored: false,
      newClass: "",
      isSaving: false,
      selectedEvidences: this.evidences,
    };
  },
  methods: {
    processMove() {
      let vm = this;
      // loop selected evidence
      vm.selectedEvidences.forEach(function (ee, index) {
        if (vm.classMoveSelected != undefined && vm.classMoveSelected.id > 0) {
          ee.inclass = vm.classMoveSelected.name;
        }

        if (vm.lessonMoveSelected != undefined && vm.lessonMoveSelected.id > 0) {
          ee.lesson_id = vm.lessonMoveSelected.id;
        }

        // update evidence
        EvidenceService.update(ee)
          .then((response) => {
            vm.classMoveSelected = {};
            vm.lessonMoveSelected = {};
          })
          .catch((err) => {
            this.failure(err);
          })
          .finally(() => {
            vm.closeMoveEvidence();
          });
      });
    },
    closeMoveEvidence() {
      this.isSaving = false;
      this.$emit('evidence-moved')
    },
    classSelect(value) {
      this.classMoveSelected = value;
    },
    failure(error) {
      this.isSaving = false;
      this.errored = true
      console.log("Pupil update error " + error);
    },
    setMoveLesson(item) {
      if (
        this.lessonMoveSelected == null ||
        this.lessonMoveSelected.id != item.id
      ) {
        this.lessonMoveSelected = item;
      } else {
        this.lessonMoveSelected = null;
      }
    },
    lessonMoveButtonPressed(object) {
      return this.lessonMoveSelected == null
        ? false
        : this.lessonMoveSelected.id == object.id;
    },
    moveEvidence() {
      this.showMove = false;
      this.$swal({
        title: "Are you sure you want to move evidence?",
        text: "This will change all selected evidence!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, change!",
      }).then((result) => {
        if (result.value) {
          this.processMove();
        }
      });
    },
  }
  
};
</script>

<style scoped>
input:focus,
textarea:focus,
select:focus {
  outline: none;
}

input[type="text"] {
  @apply m-0 px-0 py-2 border-none h-auto rounded-none;
}

input[type="text"]:focus {
  border-bottom: 1px solid #a0aec0;
}

::-webkit-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

::-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-ms-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}
</style>
